module.exports = __webpack_public_path__ + "static/RemoteLogo-24c33686657bc83321c278f288b17f0f.png";